import { AgChartProps, AgCharts } from "ag-charts-react";
import { useTranslation } from "react-i18next";
import { formatToShortCst } from "../../../../utils/formatToShortCst";
import { DeviceData } from "../../../../types/DeviceData";

interface SummitChartProps {
    deviceData: DeviceData[];
}

export default function SummitCharts({ deviceData }: SummitChartProps) {
  const { t } = useTranslation();

  const formatedData = () =>
    deviceData.map(item => {
      return {
        ...item,
        createdAt: formatToShortCst(item.createdAt || ''),
      };
    });

  const tempChartOptions: AgChartProps['options'] = {
    title: {
        text: t('sites.tempChartTitle'),
    },
    data: formatedData(),
    series: [
        {
            type: "line",
            xKey: "createdAt",
            yKey: "data.t1F",
            yName: "t1",
            marker: {
                enabled: false,
            },
        },
        {
            type: "line",
            xKey: "createdAt",
            yKey: "data.t2F",
            yName: "t2",
            marker: {
                enabled: false,
            },
        },
        {
            type: "line",
            xKey: "createdAt",
            yKey: "data.t3F",
            yName: "t3",
            marker: {
                enabled: false,
            },
        },
    ],
    axes: [
        {
            type: "category",
            position: "bottom",
            reverse: true,
            label: {
                enabled: false,
            },
        },

        {
            type: "number",
            position: "left",
            title: {
                text: t('sites.temperature'),
            },
        },
    ],
};

const pressureChartOptions: AgChartProps['options'] = {
    title: {
        text: t('sites.pressureChartTitle'),
    },
    data: deviceData,
    series: [
        {
            type: "line",
            xKey: "createdAt",
            yKey: "data.p1Psi",
            yName: "p1",
            marker: {
                enabled: false,
            },
        },
        {
            type: "line",
            xKey: "createdAt",
            yKey: "data.p2Psi",
            yName: "p2",
            marker: {
                enabled: false,
            },
        },
    ],
    axes: [
        {
            type: "category",
            position: "bottom",
            reverse: true,
            label: {
                enabled: false,
            },
        },

        {
            type: "number",
            position: "left",
            title: {
                text: t('sites.pressure'),
            },
        },
    ],
};

const ampChartOptions: AgChartProps['options'] = {
    title: {
        text: t('sites.ampsChartTitle'),
    },
    data: deviceData,
    series: [
        {
            type: "line",
            xKey: "createdAt",
            yKey: "data.l1Arms",
            yName: "l1",
            marker: {
                enabled: false,
            },
        },
        {
            type: "line",
            xKey: "createdAt",
            yKey: "data.l2Arms",
            yName: "l2",
            marker: {
                enabled: false,
            },
        },
    ],
    axes: [
        {
            type: "category",
            position: "bottom",
            reverse: true,
            label: {
                rotation: -45,
                minSpacing: 5,
                enabled: false,
            },
        },

        {
            type: "number",
            position: "left",
            title: {
                text: t('sites.ampsTitle'),
            },
        },
    ],
};

  return (
    <>
    <AgCharts options={tempChartOptions} />
    <AgCharts options={pressureChartOptions} />
    <AgCharts options={ampChartOptions} />
</>
  )
}